import React from 'react'
import { change, InjectedFormProps, FormAction } from 'redux-form'
import { Dispatch } from 'redux'

import ListingFiltersComponent from '@cinch/oxd-components/dealer-listing-filters/src'
import { trackNewVehicles } from '@cinch/oxd-utils/analytics/src/product-display'

import { DELIVERY_OPTION } from '@cinch/oxd-containers/delivery-preference/src'
import getValuesFromQuery from './get-values-from-query'
import { FORM_NAME, initialValues, FiltersPropsFromDispatch } from './listing-filters.container'

export const getLocationByUrlParams = (urlParamsFromRouter: Cinch.FilterFormData, browserLocation: any) => {
  const { latitude, longitude, location, distance } = urlParamsFromRouter

  const missingLocationFromRouter = !latitude || !longitude || !location
  if (missingLocationFromRouter) {
    return browserLocation
  }

  return {
    ...browserLocation,
    latitude,
    longitude,
    distance,
    location: decodeURIComponent(location!),
  }
}

interface ListingFiltersWrapperProps {
  deliveryOption?: Cinch.FilterFormData['deliveryOption']
  locationData?: Pick<Cinch.UserProfileRequest, 'latitude' | 'longitude' | 'location' | 'distance'>
  moneyData?: Cinch.Budgets
  vehiclesFromState?: Cinch.DealerVehicleAdvertSummary[]
  dispatch?: Dispatch<FormAction>
}
type IListingFiltersWrapperMergedProps = ListingFiltersWrapperProps & InjectedFormProps & FiltersPropsFromDispatch

const ListingFiltersWrapper: React.FC<IListingFiltersWrapperMergedProps> = ({ dispatch, ...props }) => {
  if (props.vehiclesFromState && props.vehiclesFromState.length > 0) {
    trackNewVehicles(props.vehiclesFromState)
  }

  const [mergedProps, setMergedProps] = React.useState<ListingFiltersWrapperProps | null>(null)
  const queryValues: Partial<Cinch.FilterFormData> = getValuesFromQuery()

  const updateReduxForm = (values: Partial<Cinch.FilterFormData>) =>
    Object.entries(values).forEach(([key, value]) => dispatch!(change(FORM_NAME, key, value)))

  const componentDidMount = () => {
    if (!Object.keys(queryValues).length) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      componentDidUpdate()

      return
    }

    const locationData = getLocationByUrlParams(queryValues, location)
    const budget = queryValues.toPrice === -1 ? props.moneyData!.budget || 0 : queryValues.toPrice!
    const deliveryOption = queryValues.deliveryOption || props.deliveryOption

    const propsLocation = props.locationData || { location: '', latitude: null, longitude: null, distance: 0 }
    const propsBudget = (props.moneyData && props.moneyData.budget) || 0

    if (
      props.updateUserProfile &&
      (locationData.location !== propsLocation ||
        locationData.latitude !== propsLocation ||
        locationData.longitude !== propsLocation ||
        locationData.distance !== propsLocation ||
        budget !== propsBudget ||
        deliveryOption !== props.deliveryOption ||
        DELIVERY_OPTION.DEALERSHIP)
    ) {
      props.updateUserProfile({ ...locationData, budget, deliveryOption })
    }
    setMergedProps({
      locationData,
      moneyData: { ...props.moneyData!, budget },
      deliveryOption,
      vehiclesFromState: props.vehiclesFromState,
      dispatch,
    })
    updateReduxForm({ ...initialValues, ...queryValues })
  }

  const componentDidUpdate = () => {
    setMergedProps({
      deliveryOption: props.deliveryOption,
      locationData: props.locationData,
      moneyData: props.moneyData,
      vehiclesFromState: props.vehiclesFromState,
      dispatch,
    })
  }

  React.useEffect(() => {
    if (mergedProps) {
      return
    }
    componentDidMount()
  })

  React.useEffect(() => {
    if (!mergedProps) {
      return
    }
    componentDidUpdate()
  }, [props.locationData, props.moneyData, props.deliveryOption])

  return <ListingFiltersComponent {...props} {...mergedProps} />
}

export default ListingFiltersWrapper

export { IListingFiltersWrapperMergedProps }
